import * as React from 'react';
import { useContext, useState } from 'react';
import { Grid } from '@material-ui/core';
import { AuthContext } from '../_auth/AuthContext';
import { IUserState } from '../_types/user';
import { ColumnDefinition, SearchQuery, SearchQueryResult, search_param } from '../_types/search';
import { GetQueryColumns, ExecuteQuery, ExportQuery, GetDefaultSearchQuery } from '../_service/reports';
import QuerySelector from '../common/Search/QuerySelector'
import { QueryDefinition } from '../_types/reports';
import QueryBuilder from '../common/Search/QueryBuilder';
import QueryResultsPaged from '../common/Search/QueryResultsPaged';
import { usePromiseTracker } from 'react-promise-tracker';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SelectorDefaults } from '../common/Search/FieldSelector';

import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {

};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }),
);


const QueryDash: React.FC<Props> = (prop: Props) => {
//const userState: IUserState = useContext(AuthContext);

const classes = useStyles();
const { promiseInProgress } = usePromiseTracker({ delay:500 });

const [cDef, setCDef] = useState<ColumnDefinition[] | null>(null);
const [query, setQuery] = useState<SearchQuery | null>(null);
const [queryDef, setQueryDef] = useState<QueryDefinition | null>(null);
const [results, setResults] = useState<SearchQueryResult | null>(null);

const { user } = useContext(AuthContext);


React.useEffect(() => {
     
  let location_id: number | null = null;
  if (user.currentLocation !== undefined && user.currentLocation != null) {
    location_id = user.currentLocation.id;
  }

  
  
  //don't do any refresh if we haven't already gotten data.
  if (queryDef && cDef) {
    let newQuery = GetDefaultSearchQuery(queryDef, cDef, location_id);
    
    setResults(null);
    setQuery((q) => { return {...newQuery}; });  
  }

}, [user]);


const handleQuerySelection = (qdef: QueryDefinition | null) => {
    
    
    setQuery(null);
    setCDef(null);
    setResults(null);

    if (qdef !== null) {
      setQueryDef(qdef);
      GetQueryColumns(qdef.cn).then((r) => {

          let location_id: number | null = null;
          if (user.currentLocation !== undefined && user.currentLocation != null) {
            location_id = user.currentLocation.id;
          }

          let newQuery = GetDefaultSearchQuery(qdef, r, location_id);
          setQuery((q) => { return {...newQuery} });
          setCDef(r);

        }
      );
    } else {
      setQueryDef(null);
    }


}

const DoExport = () => {

  if (query) {

    let expQ = { ... query};
    expQ.Page = 0;
    expQ.PageSize = 100;
   
    ExportQuery(expQ, "locations").then((s) => {


      

      if (s) {
  

        var csvURL = window.URL.createObjectURL(s.contents);
        let tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', s.fileName);
        tempLink.click();
        tempLink.remove();
      }
    });
  }
}

const DoSearch = () => {
  
  if (query) {

    query.Page = 0;
    query.PageSize = 50;
    query.query_uuid = null;

    setQuery((q) => { return {...query}});

    ExecuteQuery(query).then(r => {

      if (r && r.Results) {
        query.Page = r.Results.Page;
        query.query_uuid = r.Results.query_uuid;
        setQuery((q) => { return {...query}});
      }
      setResults(r);

    });
  }

}

const nextPage = () => {
  if (query && results && results.Results && results.Results.Results) {

    query.Page = results.Results.Page as number;
    
    setQuery((q) => { return {...query}});

    if (results.Results.Remaining != null && results.Results.Remaining > 0) { 
      ExecuteQuery(query).then(r => {
        setResults(r);
      })
    }
  }
}

const prvPage = () => {
  if (query && results && results.Results && results.Results.Results) {

    if (results.Results.Page != null && results.Results.Page > 1) {
      let page:number = query.Page as number;
      query.Page = page - 1;
      setQuery((q) => { return {...query}});   
      ExecuteQuery(query).then(r => {
        setResults(r);
      })
    }
  }
}

const toggleFilter = (cn: string) => {
  let column = cDef?.find(g => g.column_cn === cn);

  if (query != null && column != null) {
    let idx = query?.queryParams.findIndex(g => g.column_cn === cn);
    if (idx !== undefined && idx > -1) {
      //remove
      query?.queryParams.splice(idx, 1);

    } else {
      let defaults = SelectorDefaults(column.selector_cn);
      query.queryParams.push({
        column_cn: cn,
        comparison: defaults.comparison,
        values: defaults.values
      })
    }
    setResults(null);
    setQuery((q) => { return {...query}});
  }

}

const editFilter = (param: search_param) => {
  if (query) {
    let filter = query.queryParams.find(g => g.column_cn === param.column_cn);
    if (filter) {
      filter.comparison = param.comparison;
      filter.values = [...param.values];
      setQuery((q) => { return {...query}});

    }
  }
}

const handleColumnSelect = (cn: string) => {

  if (query) {
      let selected = query.columns.findIndex(g => g === cn);
      if (selected > -1) {
   
          let primary = cDef?.find(g => g.column_cn === cn);
          if (primary && cn !== primary.column_cn) {
            query.columns.splice(selected, 1)
          } else {
            query.columns.splice(selected, 1)
          }
          
      } else {
   
          query.columns.push(cn);
      }
   

      setResults(null);
      setQuery((q) => { return {...query}; });
  }
}

const handleColumnSort = (cn: string) => {

  if (query && cDef) {
      let primary = cDef.find(g => g.primary);
      let selected = query.KeyFields.findIndex(g => g === cn);
      let keys:string[] = [...query.KeyFields];

      if (selected > -1) {
        //don't remove primary
        if (primary && primary.column_cn !== cn) {
          keys.splice(selected, 1);  
        } else if (!primary) {
          keys.splice(selected, 1);
        }
        
      } else {
        keys.push(cn);
      }


      //if we have a primary key, and we're sorting on something else,
      //then we need to add primary key to the sort.
      if (primary && keys.length > 0) {
        //remove primary from sort
        let primaryIdx = keys.findIndex(g => g === primary?.column_cn);
        if (primaryIdx !== undefined && primaryIdx > -1) {
          keys.splice(primaryIdx, 1);
        }
        keys.push(primary?.column_cn);
      }

      keys.forEach(g => {
        if (query.columns.indexOf(g) === -1) {
          query.columns.push(g);
        }
      })

      query.KeyFields = keys;
      
      setResults(null);
      setQuery((q) => { return {...query}; });

      
  }
}

/*
selector
field selector (select fields, sorts)
query builder 
results viewer (paging / download)

*/

return (
    <React.Fragment>

      <Backdrop className={classes.backdrop} open={promiseInProgress}>
        <CircularProgress color="inherit"/>
      </Backdrop>
   
    <Grid container direction="column" justify="flex-start" alignItems="stretch">
          <Grid item>
            <QuerySelector onChange={handleQuerySelection} initialValue={'Location'} />

          </Grid>
          <Grid item>
            <QueryBuilder 
              columns={cDef} 
              query={query} 
              selectColumn={handleColumnSelect}
              sortColumn={handleColumnSort}
              filterColumn={toggleFilter}
              editFilter={editFilter}
              doSearch={() => {DoSearch()}}
              />
          </Grid>
          <Grid item>
            <QueryResultsPaged results={results} PageForward={ () => { nextPage(); } } PageBackward={ () => { prvPage();} } Export={() => { DoExport(); }} />
          </Grid>
    </Grid>
    </React.Fragment>
)
}

export default QueryDash;